import React from 'react';
import {Button, CircularProgress, Divider, LinearProgress, Paper, withStyles} from "material-ui";
import {connect} from "react-redux";
import {CompanyForm} from "../../forms/company";
import {closeGetCompanyFetch, closePutCompanyFetch, getCurrentCompany, putCompany} from "../../redux/actions/companies";
import {snackMessageShow} from "../../redux/actions/snack_message";

export class CompanyComponent extends React.Component {

    componentDidMount = () => {
        document.title = '会社プロフィール | 三島事務所';
        this.props.getCurrentCompany();
    };

    onUpdateSubmit = () => {
        this.refs.updateForm.submit();
    };

    onClickSubmitButton = (values) => {
        this.props.onClickSubmitButton(values);
    };

    render() {

        const {classes, isGetCompanyFetch, isPutCompanyFetch, errors, company} = this.props;

        return (
            <div className={classes.root}>
                <Paper>
                    <div className={classes.container}>
                        {isGetCompanyFetch ? <CircularProgress/> :
                            <CompanyForm
                                ref="updateForm"
                                errors={errors}
                                onSubmit={this.onClickSubmitButton}
                                initialValues={company}/>}
                    </div>
                    <Divider/>
                    {!isGetCompanyFetch ?
                        <div className={classes.footer}>
                            <Button
                                disabled={isPutCompanyFetch}
                                onClick={this.onUpdateSubmit}
                                color="primary">アップデート
                            </Button>
                        </div> : null}
                    {isPutCompanyFetch ? <LinearProgress/> : null}

                </Paper>
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        padding: theme.spacing.unit * 3,
    },
    container: {
        padding: theme.spacing.unit * 3
    },
    footer: {
        padding: theme.spacing.unit,
        textAlign: 'right',
    },
});

CompanyComponent = withStyles(styles)(CompanyComponent);
CompanyComponent = connect(
    (state) => {
        return {
            company: state.companies.company,
            isGetCompanyFetch: state.companies.isGetCompanyFetch,
            isPutCompanyFetch: state.companies.isPutCompanyFetch,
            errors: state.companies.errors,
        }
    },
    (dispatch) => {
        return {
            getCurrentCompany: () => {
                dispatch(getCurrentCompany());
                setTimeout(() => {
                    dispatch(closeGetCompanyFetch());
                }, 500);
            },
            onClickSubmitButton: (company) => {
                dispatch(putCompany(company)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePutCompanyFetch());
                        switch (response.type) {
                            case 'API_PUT_COMPANY_FAIL':
                                dispatch(snackMessageShow('会社情報の更新に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('会社情報を更新しました'));
                        }
                    }, 500);
                });
            },
        }
    }
)(CompanyComponent);


// WEBPACK FOOTER //
// ./src/containers/company/index.js